import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserService from "../../../services/user.service";
import Carousel from "react-bootstrap/Carousel";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import { selectAllCatalogItems, getAdminCatalog, catalogTotalCount, searchCatalog } from '../../../reducers/catalog';
import NonCatalogProduct  from "./NonCatalogProduct";
import { useParams, useSearchParams } from "react-router-dom";
import Menu from './Menu';
import { selectAllMenuItems } from '../../../reducers/menu';
import MSMPagination from '../../MSMPagination';
import CatalogService from '../../../services/catalog.service';
import { PersonCircle, Cart, Search, Pencil } from 'react-bootstrap-icons';
import Form from "react-bootstrap/Form";
import ClipLoader from "react-spinners/ClipLoader";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Catalog = () => {
  let { categoryId } = useParams();
  const [ searchParams, setSearchParams ] = useSearchParams();

  const dispatch = useDispatch();
  const catalog = useSelector(selectAllCatalogItems);

  const [resetPagination, setResetPagination] = useState(false);
  const [range, setRange] = useState([1,12]);
  const [content, setContent] = useState(null);
  const [catalogTotal, setCatalogTotal] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const catalogStatus = useSelector(state => state.catalog.adminCatalogStatus)
  
/*  useEffect(() => {
    if (catalogStatus === 'idle') {
      if(categoryId === 0) {
        //categoryId = menu.menu[0].id;
      }
      dispatch(getAdminCatalog([categoryId, range[0], range[1]]));
    }
  }, [catalogStatus, dispatch]);

  useEffect(() => {
    dispatch(getAdminCatalog([categoryId, range[0], range[1]]));
  }, [categoryId, dispatch]);
  
  useEffect(() => {
    if(searchParams.get("searchTerm")) {
      dispatch(searchCatalog([searchParams.get("searchTerm"),range[0], range[1]]));
    } else {
      dispatch(getAdminCatalog([categoryId, range[0], range[1]]));
    }
  }, [range, dispatch]);
*/

/*  if (catalogStatus === 'loading') {
    content = <Spinner text="Loading..." />
  } else if (catalogStatus === 'succeeded') {
    content = catalog.catalog.map(catalogItem => (
      <NonCatalogProduct product={catalogItem} showColors="hide" />
      
    ));
  } else if (catalogStatus === 'failed') {
    content = <div>error</div>
  }
*/  
  const reloadData = async (range) => {
    setLoading(true);
    var searchItems = await CatalogService.searchAdminCatalog(searchTerm, range);
    console.log(searchItems);
    var newContent = searchItems.data.map(catalogItem => (
      <NonCatalogProduct product={catalogItem} showColors="hide" />
    ));
    setContent(newContent);
    setCatalogTotal(searchItems.count);
    setLoading(false);

  }

  const loadSanmarClick = async (e) => {
    setLoading(true);
    setErrorMessage(null);

      var searchItems = await CatalogService.loadNewSanmarProduct(searchTerm);
      console.log("SANMAR ITEMS FOUND", searchItems);

      var searchItems = await CatalogService.searchAdminCatalog(searchTerm, [1,12]);
      console.log(searchItems);
      var newContent = searchItems.data.map(catalogItem => (
        <NonCatalogProduct product={catalogItem} showColors="hide" />
      ));
      setContent(newContent);
      setCatalogTotal(searchItems.count);
      if(searchItems.count == 0) {
        setErrorMessage("Sanmar Load Failed");
      } else {
        setErrorMessage(null);
      }
      setLoading(false);
  }


  const handleSearchSubmit = async (e) => {
    setLoading(true);
    setErrorMessage(null);

    e.preventDefault();
    const formData = new FormData(e.target), 
        formDataObj = Object.fromEntries(formData.entries());
    
    setSearchTerm(formDataObj.searchTerm);

    var searchItems = await CatalogService.searchAdminCatalog(formDataObj.searchTerm, [1,12]);
    console.log(searchItems);
    var newContent = searchItems.data.map(catalogItem => (
      <NonCatalogProduct product={catalogItem} showColors="hide" />
    ));
    setContent(newContent);
    setCatalogTotal(searchItems.count);
    if(searchItems.count == 0) {
      setErrorMessage("No products were found");
      console.log("NO ITEMS");
    } else {
      setErrorMessage(null);
    }
    setLoading(false);

    //dispatch(searchCatalog(0,10, formDataObj.searchTerm));
  }

  return (
    <Container>
      <Row>
        Search: 
        <Form noValidate onSubmit={handleSearchSubmit}>
            <Form.Group className="nav-form" controlId="formBasicEmail">
              <Form.Control type="text" placeholder="Search" name="searchTerm" />
              <Button variant="secondary" type="submit">
              <Search />
            </Button>
            </Form.Group>
          </Form>
        </Row>
        <Row>
          <MSMPagination reload={reloadData} perPage={range[1]} total={catalogTotal} reset={resetPagination} />
        </Row>
        <Row>
            { content }
            {errorMessage && 
              <div class="flex-container">
                <div>
                </div>
                <div>
                {errorMessage}<br /> <br />
                <Button variant="secondary" onClick={loadSanmarClick}>Load From Sanmar</Button>
                </div>
              </div>
            }
            {loading &&
              <ClipLoader
                loading={loading}
                size={50}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            }
        </Row>
    </Container>
  );
};
export default Catalog;